<template>
  <div class="w-full px-[20px] mt-[24px] text-[16px] enterAmount">
    <Image v-if="txBanner.state == 'Enabled'" @click="handleJumpLink" class="w-full h-[174px] rounded-2xl"
      :src="txBanner.picture" alt="" />
    <div class="flex items-center">
      <span>{{ $t("Saque.EnterAmount.MyBalance") }}</span>
      <div class="flex justify-between items-center ml-[13px]">
        <div class="flex items-center gap-[13px]">
          <span class="w-[220px] text-[var(--theme-primary)]">
            {{ formatter().format(sharedData.totalMoney) }}
            <span class="text-[12px]">R$</span>
          </span>
        </div>
      </div>
    </div>
    <div class="w-full h-[35px] m-auto overflow-x-auto relative mt-4" v-if="props.isChannelLoading">
      <div class="absolute flex gap-[10px]">
        <template v-if="props.channelList?.length">
          <template v-for="item in props.channelList" :key="item.methodId">
            <div class="relative">
              <div
                :class="[
                  'w-[85px] h-[35px] text-[18px] flex justify-center items-center rounded-[6px] cursor-pointer',
                  sharedData.methodId === item.id
                    ? 'active_tab_btn'
                    : 'bg-[var(--inner-table-bg-color40)] text-[#bdbec0]',
                ]"
              >
                PIX
              </div>
              <div v-if="item.type === 'TestPay'"
                class="absolute top-[-2px] right-[-10px] w-[20px] h-[20px] rounded-full bg-[red] text-white text-[10px] flex-center">
                T
              </div>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="text-[12px] flex justify-center items-center">
            <Image :src="noData" alt="" class="w-[24px] h-[24px] mr-[10px]" />
            <span class="text-[12px] text-[#FF3B30]">{{ $t("Deposit.noChannel") }}</span>
          </div>
        </template>
      </div>
    </div>
    <div class="mt-[30px] font-bold text-[#fff]">
      {{ $t("Saque.EnterMessage.WithdrawalAmount") }}
    </div>
    <div class="mt-[20px]">
      <div class="relative block mt-[20px]">
        <van-field
          class="webkit-tap-none block border-none bg-[var(--inner-table-bg-color40)] w-full h-[44px] rounded-xl py-2 pl-[50px] pr-3 shadow-sm focus:bg-[var(--inner-table-bg-color70)]"
          :placeholder="`valor(${formatNumberAsMoney(
            formatter().format(sharedData.limitMin)
          )} ~ ${formatNumberAsMoney(formatter().format(sharedData.limitMax))})`" v-model="sharedData.amount"
          :disabled="sharedData.limitAmount > 0 || sharedData.totalMoney == 0" inputmode="numeric"
          @input="handleInput" />
        <span class="w-[24px] h-[24px] absolute left-[15px] top-[11px] text-[#FFDF12]">
          R$
        </span>
      </div>
      <template v-if="Number(sharedData.limitAmount) > 0">
        <div
          class="w-full h-[54px] mt-[10px] pl-[13px] rounded-xl border-[1px] border-solid border-[#fff] flex items-center tip">
          <div class="flex items-center gap-[13px]">
            <Image class="w-[24px] h-[24px] icon" :src="Icon" alt="" />
            <span class="w-[250px] leading-[18px] text-[15px] text-[#fff]/45 txt">
              {{
                $t("Saque.EnterAmount.WithdrawalRestrictions", {
                  limitAmount: formatter().format(sharedData.limitAmount),
                })
              }}
            </span>
          </div>
        </div>
      </template>

      <template v-if="sharedData.generalMoneyArr.length">
        <div class="flex justify-between flex-wrap mt-[10px]">
          <div
            v-for="item in sharedData.generalMoneyArr"
            :key="item.amount"
            class="w-[100px] text-white mr-[5px] mt-[10px]"
          >
            <button
              :class="[
                '!h-[38px] !border-[1px] !font-[300] !border-solid !border-[#fff]/50 !rounded-[8px]',
                Number(sharedData.amount) !== Number(item.amount) || isAmountValid(item)
                  ? 'primaryBtn_transparent'
                  : 'primaryBtn',
                isAmountValid(item) ? 'opacity-40' : '',
              ]"
              :disabled="isAmountValid(item)"
              @click="
                () => {
                  sharedData.amount = item.amount;
                }
              "
            >
              <span
                :class="[
                  Number(sharedData.amount) === Number(item.amount) &&
                  !isAmountValid(item)
                    ? 'text-[#151A1F]  font-bold'
                    : '',
                  'text-[14px]',
                ]"
              >
                R$ {{ formatter().format(item.amount) }}
              </span>
            </button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import noData from "@/views/Deposito/images/noData.png";
import { getAdvertisingSpaceInfo } from "@/api/saque";
import { formatter, formatNumberAsMoney } from "@/utils";
import Icon from "../images/icon.png";
const route = useRoute();
const router = useRouter();
const searchParams: any = ref(route.query);
const txBanner = ref<any>({});
const sharedData: any = inject("sharedData");
const emit = defineEmits(["next"]);
// 定义 channelList 中 item 的接口
interface ChannelItem {
  methodId: string | number; // 确保 methodId 的类型与实际数据匹配
  id: string | number; // id 和 methodId 可能相同，根据实际 API 返回确定
  type: string;
  supportType: string;
  minPayAmt: number;
  maxPayAmt: number;
  payAmounts: number[]; // 假设 payAmounts 是数字数组
  // 如果还有其他属性，也要在这里定义
}

const props = defineProps<{
  channelList: ChannelItem[];
  isChannelLoading: boolean;
}>();

const isAmountValid = (item: any) => {
  return (
    Number(item.amount) > sharedData.value.limitMax ||
    Number(item.amount) < sharedData.value.limitMin ||
    Number(item.amount) > sharedData.value.totalMoney ||
    Number(sharedData.value.limitAmount) > 0
  );
};

// 查询广告位信息
const queryAdvertisingSpaceInfo = async () => {
  try {
    const { data, code } = await getAdvertisingSpaceInfo({ language: "pt" });
    if (code === 1) {
      txBanner.value = data || {};
    }
  } catch (error) {
    console.log(error);
  }
};
const handleInput = (e: any) => {
  if (sharedData.value.totalMoney == 0) {
    return;
  }
  const value = e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");

  const min =
    sharedData.value.limitMax > sharedData.value.totalMoney
      ? sharedData.value.totalMoney
      : sharedData.value.limitMax;
  const num = Number(value) > min ? min.toString() : value;
  // 小数点后面最多输入两位数
  const formattedNum = num.includes(".")
    ? num.split(".")[0] + "." + num.split(".")[1].slice(0, 2)
    : num;
  sharedData.value.amount = formattedNum;
  if (sharedData.value.amount == 0) {
    sharedData.value.amount = "";
  }
};
//点击图片跳转
const handleJumpLink = () => {
  if (txBanner.value.hyperlink) {
    if (txBanner.value.hyperlinkType === "BUILT_IN_LINK") {
      // 内置链接
      const queryString = new URLSearchParams(searchParams.value as any).toString();
      const activityIdParam = txBanner.value.activityId
        ? `&activityId=${txBanner.value.activityId}`
        : "";
      const finalUrl = `${txBanner.value.hyperlink}?${queryString}${activityIdParam}`;
      router.push(finalUrl);
    } else if (
      txBanner.value.hyperlinkType === "CUSTOM_LINK" ||
      txBanner.value.jumpMethod === "INNER_JUMP"
    ) {
      // 自定义链接 或 外跳链接
      window.open(txBanner.value.hyperlink, "_blank");
    } else if (txBanner.value.jumpMethod === "EXTERNAL_JUMP") {
      window.location.href = txBanner.value.hyperlink;
    }
  }
};

// const handleClick = (item: any) => {
//   sharedData.value.supportTypes = item.supportType;
//   sharedData.value.limitMin = Number(item.minPayAmt);
//   sharedData.value.limitMax = Number(item.maxPayAmt);
//   sharedData.value.payType = item.type;
//   sharedData.value.methodId = item.id;
//   sharedData.value.generalMoneyArr = item.payAmounts
//     ? item.payAmounts.map((item: any) => {
//         return {
//           amount: item,
//         };
//       })
//     : [];
// };

onMounted(() => {
  queryAdvertisingSpaceInfo();
});
</script>

<style lang="scss" scoped></style>
